import React from 'react';
import StaffForm from '../../Components/Staff/StaffForm';

export default function ReceptionistForm() {
  return (
    <StaffForm
      role="receptionist"
      title="Receptionist"
      returnUrl="/receptionist"
    />
  );
}
